module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray@2x-1ee50352082275930522cfb7f2a0e1b3.png";